// extracted by mini-css-extract-plugin
export default {"alignStart":"LabSearchTile__alignStart__eZtcX","labImage":"LabSearchTile__labImage__BZmtt","labLineIcon":"LabSearchTile__labLineIcon__RjxFH","labBody":"LabSearchTile__labBody__Hwk6f","labIcon":"LabSearchTile__labIcon__e8dXY"};
    if(module.hot) {
      // 1753686718415
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  